import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type Db, must, useDb } from './db';

export const DEMO_PERSONAS = [
  'director',
  'teacher',
  'parent',
  'student',
  'student2',
  'psychologist',
  'senior',
  'abroad',
] as const;
export type DemoPersona = (typeof DEMO_PERSONAS)[number];

/** Demo builds only: one tap signs in as a persona (the Edge Function answers 404 in production). */
export async function demoLogin(db: Db, persona: DemoPersona): Promise<void> {
  const { data, error } = await db.functions.invoke('demo-login', { body: { persona } });
  if (error) throw error;
  const tokens = data as { access_token: string; refresh_token: string };
  const { error: sessionError } = await db.auth.setSession(tokens);
  if (sessionError) throw sessionError;
}

/** Demo stacks only («Урок у класі зараз»): the same lesson, going on in the classroom now. */
export function useStartDemoClassLesson() {
  const db = useDb();
  const client = useQueryClient();
  return useMutation({
    mutationFn: async () => must(await db.rpc('demo_start_class_lesson')),
    onSettled: () => client.invalidateQueries({ queryKey: ['lessons'] }),
  });
}

/**
 * Demo stacks only («Онлайн-урок зараз»): the demo teacher's lesson with the demo student goes
 * on right now, online, on any day. The database function exists only in demo seeds.
 */
export function useStartDemoLesson() {
  const db = useDb();
  const client = useQueryClient();
  return useMutation({
    mutationFn: async () => must(await db.rpc('demo_start_live_lesson')),
    onSettled: () => client.invalidateQueries({ queryKey: ['lessons'] }),
  });
}
